const cookie = require('cookie_js').cookie;
const config = require('./config.yaml');
const text = require('./text.yaml')[templateVars.lang];

$('document').ready(function () {
	if (cookie('shown_cookies_law') != 'true' && !templateVars.page.disableCookieLaw) {
		const moreLink = getUrl(config.linkToPage);
		var openAnimation = {height: 'toggle'};
		var closeAnimation = {height: 'toggle'};

		if (config.isStatic) {
			openAnimation = {height: 'toggle'};
			closeAnimation = {height: 'toggle'};
		}

		function getUrl(urlQuery) {
			return urlQuery
				.replace(/\/$/g, '')
				.replace('${rootUrl}', templateVars.siteLangRootUrlRel);
		}

		var cookieLawNotify = noty({
			layout: 'inline',
			type: 'information',
			text: text.message.replace('{{siteTitle}}', templateVars.structure.title),
			theme: 'cookie-law noty_container' + (config.isStatic ? ' noty_container--static' : ' noty_container--fixed'),
			template: `<div class="noty_message">
				<span class="noty_title">${text.title}</span>
				<span class="noty_text"></span>
				<a class="popup-link" target="_blank" href="${moreLink}" title="${text.linkText}">${text.linkText}</a>
			</div>`,
			buttons: [
				{
					addClass: 'cookie-law__apply', text: text.buttonText, onClick: function ($noty) {
						cookie.set('shown_cookies_law', 'true', {path: '/', expires: 365});

						$noty.close();

						if (config.isStatic) {
							var nextNoty = $('.noty_inline_layout_container .noty_container').eq(1);

							if (nextNoty != undefined && nextNoty.hasClass('noty_container--fixed')) {
								$('body').velocity({marginTop: 0}, {duration: 400});
							} else {
								$('body').velocity({marginTop: nextNoty.height()}, {duration: 270});
							}
						}

						if (config.showOneTime) {
							cookie.set('shown_cookies_law_ignored', 'false', {path: '/', expires: 365});
						}
					}
				}
			],
			animation: {
				open: openAnimation,
				close: closeAnimation,
				easing: 'swing',
				speed: 400
			},
			callback: {
				onShow: function () {
					if (config.isStatic) {
						var $body = $('body');
						var notyHeight = $('.cookie-law').height();

						$body.css('margin-top', '1px');

						$body.velocity({marginTop: notyHeight}, {duration: 460});
					}

					if (config.showOneTime) {
						cookie.set('shown_cookies_law_ignored', 'true', {path: '/', expires: 365});
					}
				},
				afterShow: function () {
					if (config.showOneTime) {
						cookie.set('shown_cookies_law', 'true', {path: '/', expires: 365});
					} else {
						if (cookie('shown_cookies_law') == undefined) {
							cookie.set('shown_cookies_law', 'first', {path: '/', expires: 365});
						} else {
							cookie.set('shown_cookies_law', 'second', {path: '/', expires: 365});
						}
					}
				}
			}
		});
	}
});



// WEBPACK FOOTER //
// ./temp/components/cookie-law/single-button/index.js